import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { IconForm } from "@domestika-dev/prudencio/dist/atoms/Icon";
import { Minus, Plus } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Box, Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Card } from "@domestika-dev/prudencio/dist/atoms/Card";
import When from "./When";

const CollapsableCard = ({
  headlineNumber,
  headlineText,
  headlineChildren,
  headlineBackgroundColor,
  paddingX,
  marginBottom,
  focusOnClick,
  openedIcon,
  closedIcon,
  children,
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const [contentHeight, setContentHeight] = useState(0);
  const cardRef = useRef(null);

  const contentRef = (node) => {
    if (node !== null && node.firstChild !== null) {
      setContentHeight(node.firstChild.getBoundingClientRect().height);
    }
  };

  const handleHeadlineClick = () => {
    setCollapsed(!collapsed);
    if (focusOnClick) {
      setTimeout(() => {
        cardRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  };

  return (
    <div ref={cardRef} style={{ width: "100%" }}>
      <Card
        paddingY={5}
        paddingX={paddingX}
        marginBottom={marginBottom}
        backgroundColor={headlineBackgroundColor}
      >
        <Flex
          justifyContent="flex-start"
          onClick={handleHeadlineClick}
          paddingRight={6}
          style={{ cursor: "pointer", position: "relative" }}
        >
          <When condition={headlineNumber !== null}>
            {() => (
              <Text size="small" fontWeight="medium" as="h2" textAlign="left" marginRight={2}>
                {headlineNumber}.
              </Text>
            )}
          </When>
          <Text size="small" fontWeight="medium" as="h2" textAlign="left">
            {headlineText}
          </Text>
          <IconForm style={{ position: "absolute", right: 0, top: "4px" }} size="small">
            {collapsed ? closedIcon() : openedIcon()}
          </IconForm>
        </Flex>
        <When condition={headlineChildren !== null}>{() => headlineChildren}</When>
        <Box
          ref={contentRef}
          style={{
            transition: "height 50ms linear",
            overflow: "hidden",
            height: collapsed ? 0 : contentHeight,
          }}
        >
          {children}
        </Box>
      </Card>
    </div>
  );
};

CollapsableCard.propTypes = {
  headlineNumber: PropTypes.number,
  headlineText: PropTypes.string.isRequired,
  headlineChildren: PropTypes.node,
  headlineBackgroundColor: PropTypes.string,
  paddingX: PropTypes.number,
  marginBottom: PropTypes.number,
  focusOnClick: PropTypes.bool,
  closedIcon: PropTypes.func,
  openedIcon: PropTypes.func,
  children: PropTypes.node.isRequired,
};

CollapsableCard.defaultProps = {
  headlineNumber: null,
  headlineChildren: null,
  headlineBackgroundColor: "copoazu",
  paddingX: 5,
  marginBottom: 2,
  focusOnClick: true,
  closedIcon: () => <Plus />,
  openedIcon: () => <Minus />,
};

export default CollapsableCard;
